import T from 'ant-design-vue/es/table/Table'
import get from 'lodash.get'
import './index.less'

export default {
  data () {
    return {
      needTotalList: [],

      selectedRows: [],
      selectedRowKeys: [],
      multipageSelRows: {
        selectedRows: [],
        selectedRowKeys: [],
        allSelRow: []
      },

      localLoading: false,
      localDataSource: [],
      localPagination: Object.assign({
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100']
      }, this.pagination),
      localSorter: Object.assign({}, this.sorter)
    }
  },
  props: Object.assign({}, T.props, {
    rowKey: {
      type: [String, Function],
      default: 'id'
    },
    flag: {
      type: String,
      default: 'add'
    },
    data: {
      type: Function,
      required: true
    },
    pageNo: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    showSizeChanger: {
      type: Boolean,
      default: true
    },
    simple: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    /**
     * {
     *   show: true,
     *   clear: Function
     * }
     */
    alert: {
      type: [Object, Boolean],
      default: null
    },
    rowSelection: {
      type: Object,
      default: null
    },
    /** @Deprecated */
    showAlertInfo: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: String | Boolean,
      // default: 'auto'
      default: true
    },
    /**
     * enable page URI mode
     *
     * e.g:
     * /users/1
     * /users/2
     * /users/3?queryParam=test
     * ...
     */
    pageURI: {
      type: Boolean,
      default: false
    },
    showTotalPager: {
      type: Boolean,
      default: true
    },
    filter: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }),
  watch: {
    'localPagination.current' (val) {
      this.pageURI && this.$router.push({
        ...this.$route,
        name: this.$route.name,
        params: Object.assign({}, this.$route.params, {
          pageNo: val
        })
      })
      this.$emit('paginationUpdated', this.localPagination)
      this.needTotalList = this.initTotalList(this.columns)
      this.selectedRowKeys = []
      this.selectedRows = []
    },

    pageNo (val) {
      Object.assign(this.localPagination, {
        current: val
      })
    },
    pageSize (val) {
      Object.assign(this.localPagination, {
        pageSize: val
      })
    },
    showSizeChanger (val) {
      Object.assign(this.localPagination, {
        showSizeChanger: val
      })
    },
    flag (val) {
      this.initData()
    },
    dataSource (newValue) {
      if (this.flag !== 'view') {
        let pageNo = this.localPagination.current || this.localPagination.pageNo
        while ((pageNo - 1) * this.localPagination.pageSize >= newValue.length) {
          pageNo--
        }
        pageNo = pageNo > 0 ? pageNo : 1
        this.localPagination.current = pageNo
        this.localPagination.pageNo = pageNo
        this.$emit('pageinfo', { current: pageNo, pageSize: this.localPagination.pageSize })
      }
    }
  },
  created () {
    const { pageNo } = this.$route.params
    const localPageNum = this.pageURI && (pageNo && parseInt(pageNo)) || this.pageNo
    this.localPagination = ['auto', true].includes(this.showPagination) && Object.assign({}, this.localPagination, {
      pageNo: localPageNum,
      pageSize: this.pageSize,
      showLessItems: true,
      showSizeChanger: this.showSizeChanger,
      simple: this.simple
    }) || false
    this.needTotalList = this.initTotalList(this.columns)
    this.initData()
  },
  methods: {
    initData () {
      switch (this.flag) {
        case 'add':
          break
        case 'view':
          this.loadData()
          break
        case 'edit':
          this.editLoadData()
          break
        default:
          break
      }
    },
    editLoadData () {
      this.localLoading = true
      const parameter = Object.assign({
        page: 1,
        pageSize: 9999
      })
      const result = this.data(parameter)
      // 对接自己的通用数据接口需要修改下方代码中的 r.pageNo, r.total, r.data
      // eslint-disable-next-line
      if ((typeof result === 'object' || typeof result === 'function') && typeof result.then === 'function') {
        result.then(r => {
          this.localDataSource = r.data // 返回结果中的数组数据
          this.localLoading = false
        })
      }
    },
    /**
     * 表格重新加载方法
     * 如果参数为 true, 则强制刷新到第一页
     * @param Boolean bool
     */
    refresh (bool = false) {
      bool && (this.localPagination = Object.assign({}, {
        current: 1, pageSize: this.pageSize
      }))
      this.clearSelected()
      this.initData()
    },
    /**
     * 加载数据方法
     * @param {Object} pagination 分页选项器
     * @param {Object} filters 过滤条件
     * @param {Object} sorter 排序条件
     */
    loadData (pagination, filters, sorter) {
      this.localLoading = true
      const parameter = Object.assign({
        page: (pagination && pagination.current) || this.showPagination && this.localPagination.current || this.pageNo,
        pageSize: (pagination && pagination.pageSize) || this.showPagination && this.localPagination.pageSize || this.pageSize
      },
      (sorter && sorter.field && {
        sortField: sorter.field
      }) || {},
      (sorter && sorter.order && {
        sortOrder: sorter.order
      }) || {}, {
        ...filters
      },
      (this.filter.category && {
        category: this.filter.category
      }) || {},
      (this.filter.searchValue && this.filter.searchValue[0] !== '' && {
        search: this.filter.searchValue
      }) || {}
      )
      const result = this.data(parameter)
      // 对接自己的通用数据接口需要修改下方代码中的 r.pageNo, r.total, r.data
      // eslint-disable-next-line
      if ((typeof result === 'object' || typeof result === 'function') && typeof result.then === 'function') {
        result.then(r => {
          if (pagination) this.$emit('pageinfo', pagination)
          this.localPagination = this.showPagination && Object.assign({}, this.localPagination, {
            current: r.pageNo || 1, // 返回结果中的当前分页数
            total: r.total || r.data.length, // 返回结果中的总记录数
            showSizeChanger: this.showSizeChanger,
            simple: this.simple,
            pageSize: (pagination && pagination.pageSize) ||
              this.localPagination.pageSize
          }) || false
          // 为防止删除数据后导致页面当前页面数据长度为 0 ,自动翻页到上一页
          if (r.data.length === 0 && this.localPagination.current && this.localPagination.current !== 1) {
            this.localPagination.current--
            this.loadData()
            return
          }

          // 这里用于判断接口是否有返回 r.total 或 this.showPagination = false
          // 当情况满足时，表示数据不满足分页大小，关闭 table 分页功能

          (!this.showPagination || !r.tota && this.showPagination === 'auto') && (this.localPagination.hideOnSinglePage = true)
          this.localDataSource = r.data // 返回结果中的数组数据
          this.localLoading = false
        })
      }
    },
    initTotalList (columns) {
      const totalList = []
      columns && columns instanceof Array && columns.forEach(column => {
        if (column.needTotal) {
          totalList.push({
            ...column,
            total: 0
          })
        }
      })
      return totalList
    },
    /**
     * 用于更新已选中的列表数据 total 统计
     * @param selectedRowKeys
     * @param selectedRows
     */
    updateSelect (selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows
      this.selectedRowKeys = selectedRowKeys
      const list = this.needTotalList
      this.needTotalList = list.map(item => {
        return {
          ...item,
          total: selectedRows.reduce((sum, val) => {
            const total = sum + parseInt(get(val, item.dataIndex))
            return isNaN(total) ? 0 : total
          }, 0)
        }
      })
    },
    /**
     * 清空 table 已选中项
     */
    clearSelected () {
      if (this.rowSelection) {
        this.multipageSelRows = {
          selectedRows: [],
          selectedRowKeys: []
        }
        this.rowSelection.onChange([], [])
        this.updateSelect([], [])
      }
    },
    /**
     * 处理交给 table 使用者去处理 clear 事件时，内部选中统计同时调用
     * @param callback
     * @returns {*}
     */
    renderClear (callback) {
      if (this.selectedRowKeys.length <= 0) return null
      return (
        <a style="margin-left: 24px" onClick={() => {
          callback()
          this.clearSelected()
        }}>清空</a>
      )
    },
    renderAlert () {
      // 绘制统计列数据
      const needTotalItems = this.needTotalList.map((item) => {
        return (<span style="margin-right: 12px">
          {item.title}总计 <a style="font-weight: 600">{!item.customRender ? item.total : item.customRender(item.total)}</a>
        </span>)
      })

      // 绘制 清空 按钮
      const clearItem = (typeof this.alert.clear === 'boolean' && this.alert.clear) ? (
        this.renderClear(this.clearSelected)
      ) : (this.alert !== null && typeof this.alert.clear === 'function') ? (
        this.renderClear(this.alert.clear)
      ) : null

      // 绘制 alert 组件
      return (
        <a-alert showIcon={true} style="margin-bottom: 16px">
          <template slot="message">
            <span style="margin-right: 12px">已选择: <a style="font-weight: 600">{this.selectedRows.length}</a></span>
            {needTotalItems}
            {clearItem}
          </template>
        </a-alert>
      )
    },
    lookRender () {
      const props = {}
      const localKeys = Object.keys(this.$data)
      const showAlert = (typeof this.alert === 'object' && this.alert !== null && this.alert.show) && typeof this.rowSelection.selectedRowKeys !== 'undefined' || this.alert

      Object.keys(T.props).forEach(k => {
        const localKey = `local${k.substring(0, 1).toUpperCase()}${k.substring(1)}`
        if (localKeys.includes(localKey)) {
          props[k] = this[localKey]
          return props[k]
        }
        if (k === 'rowSelection') {
          if (showAlert && this.rowSelection) {
            // 如果需要使用alert，则重新绑定 rowSelection 事件
            props[k] = {
              selectedRows: this.selectedRows,
              selectedRowKeys: this.selectedRowKeys,
              onChange: (selectedRowKeys, selectedRows) => {
                this.updateSelect(selectedRowKeys, selectedRows)
                typeof this[k].onChange !== 'undefined' && this[k].onChange(selectedRowKeys, selectedRows)
              }
            }
            return props[k]
          } else if (!this.rowSelection) {
            // 如果没打算开启 rowSelection 则清空默认的选择项
            props[k] = null
            return props[k]
          }
        }
        props[k] = this[k]
        // if (this.flag === 'view') {
        //   props.rowSelection = null
        // }
        return props[k]
      })
      const scopedSlots = this.showTotalPager && (this.localPagination.total || this.dataSource.length) ? {
        footer: () => {
          const length = this.localPagination.total || this.dataSource.length || 0
          return <div class="footer-batch">
            <div class="table-sel-num">数据 {length} 条</div>
          </div>
        }
      } : {}
      // props.dataSource = this.localDataSource
      const table = (
        <a-table {...{ props, scopedSlots: { ...scopedSlots, ...this.$scopedSlots } }} onChange={this.loadData}>
          { Object.keys(this.$slots).map(name => (<template slot={name}>{this.$slots[name]}</template>)) }
        </a-table>
      )
      return (
        <div class="m-table">
          { showAlert ? this.renderAlert() : null }
          { table }
        </div>
      )
    },
    onChange (e) {
      this.localPagination = Object.assign({}, e)
      this.$emit('pageinfo', e)
    },
    onBatchDel () {
      const length = this.multipageSelRows.allSelRow && this.multipageSelRows.allSelRow.length || 0
      if (length) {
        this.$confirm({
          title: `总共${length}条，确定要全部删除？`,
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk: () => {
            this.$emit('batch-del')
          }
        })
        return
      }
      this.$message.info('请先选中要删除的内容')
    }
  },
  render () {
    switch (this.flag) {
      case 'add':
      case 'edit':
      case 'repeal':
      case 'localData':
        const props = {}
        Object.keys(T.props).forEach(k => {
          props[k] = this[k]
          if (k === 'rowSelection') {
            if (this.rowSelection) {
              // 如果需要使用alert，则重新绑定 rowSelection 事件
              props[k] = {
                selectedRows: this.multipageSelRows.selectedRows[this.localPagination.pageNo] || this.selectedRows,
                selectedRowKeys: this.multipageSelRows.selectedRowKeys[this.localPagination.pageNo] || this.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                  this.multipageSelRows.selectedRows[this.localPagination.pageNo] = selectedRows
                  this.multipageSelRows.selectedRowKeys[this.localPagination.pageNo] = selectedRowKeys
                  this.multipageSelRows = Object.assign({}, this.multipageSelRows)
                  const selRows = this.multipageSelRows.selectedRows.reduce(function (a, b) { return a.concat(b) })
                  const selRowKeys = this.multipageSelRows.selectedRowKeys.reduce(function (a, b) { return a.concat(b) })
                  this.multipageSelRows.allSelRow = selRows || []
                  this.updateSelect(selRowKeys, selRows)
                  typeof this[k].onChange !== 'undefined' && this[k].onChange(selRowKeys, selRows)
                }
              }
              if (this.rowSelection.getCheckboxProps) {
                props[k].getCheckboxProps = this.rowSelection.getCheckboxProps
              }
              return props[k]
            } else if (!this.rowSelection) {
              // 如果没打算开启 rowSelection 则清空默认的选择项
              props[k] = null
              return props[k]
            }
          }
          if (this.flag === 'localData') {
            props.rowSelection = null
          }
          return props[k]
        })
        props.pagination = this.localPagination

        // const scopedSlots = this.rowSelection && this.dataSource.length && this.flag !== 'localData' ? {
        //   footer: () => {
        //     const length = this.multipageSelRows.allSelRow && this.multipageSelRows.allSelRow.length || 0
        //     return <div class="footer-batch">
        //       <div class="table-sel-num">已选<span>{length}</span>项</div>
        //       <a-button type="danger" ghost onclick={() => this.onBatchDel()} >批量删除</a-button>
        //     </div>
        //   }
        // } : {}
        const scopedSlots = this.showTotalPager && (this.localPagination.total || this.dataSource.length) ? {
          footer: () => {
            const length = this.localPagination.total || this.dataSource.length || 0
            return <div class="footer-batch">
              <div class="table-sel-num">数据 {length} 条</div>
            </div>
          }
        } : {}
        const table = (
          <a-table {...{ props, scopedSlots: { ...scopedSlots } }} onChange={this.onChange}>
            { Object.keys(this.$slots).map(name => (<template slot={name}>{this.$slots[name]}</template>)) }
          </a-table>
        )
        return <div class="m-table">
          {table}{this.localPagination.total}
        </div>

      case 'view':
        return this.lookRender()
      default:
        break
    }
  }

}
